// extracted by mini-css-extract-plugin
export default {"hero":"SmallHero__hero--22","xs":"SmallHero__xs--rl","md":"SmallHero__md--1_","sm":"SmallHero__sm--1-"};